"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterAsync = void 0;
const tslib_1 = require("tslib");
/**
 * The async variant of the Array.filter() method that
 * @param values An iterable of elements to filter
 * @param callbackFn The async callback that will be executed on the elements
 * @returns Promise<T[]>
 */
const filterAsync = (values, callbackFn) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const returns = [];
    for (const value of values) {
        ;
        (yield callbackFn(value)) && returns.push(value);
    }
    return returns;
});
exports.filterAsync = filterAsync;
;
Array.prototype.filterAsync = function (callbackFn) {
    return exports.filterAsync(this, callbackFn);
};
//# sourceMappingURL=filter-async.js.map